import React from 'react';
import { connect } from 'react-redux'
import TransactionVerify from '../component/TransactionVerify';
import toolactions from '../redux/actions/tools';
import transactionactions from '../redux/actions/transactions';


const mapStateToProps = (state) => {
    return {
        userInfo: state.tools?.userInfo,
        verifyInfo: state.transaction.verify,
        coins: state.setting.coins,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchUserByAddress: (params, callback) => {
            dispatch(toolactions.onFetchUserByAddress(params, callback));
        },
        verifyTransaction: (data, callback = () => void(0)) => {
            dispatch(transactionactions.verifyTransaction(data, callback));
        },
        acceptTransaction: (data) => {
          dispatch(transactionactions.acceptTransaction(data));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TransactionVerify)
